import { LOCAL, DEVELOP, STAGE, PRODUCTION } from './environments';

export const envApiUriMapping = {
  [LOCAL]: {
    customerBillingUri: process.env.LOCAL_BACKEND
      ? 'http://localhost:8080/graphql'
      : 'https://stage-spotlight-platform.appspot.com/graphql',
    experienceNotificationsUri: 'https://gateway.sunrundev.com/majstg-experience-notifications/',
  },
  [DEVELOP]: {
    customerBillingUri: 'https://dev-spotlight-platform.appspot.com/graphql',
    experienceNotificationsUri: 'https://gateway.sunrundev.com/majstg-experience-notifications/',
  },
  [STAGE]: {
    customerBillingUri: 'https://stage-spotlight-platform.appspot.com/graphql',
    experienceNotificationsUri: 'https://gateway.sunrun.com/majstg-experience-notifications/',
  },
  [PRODUCTION]: {
    customerBillingUri: 'https://prd-spotlight-platform.appspot.com/graphql',
    experienceNotificationsUri: 'https://gateway.sunrun.com/experience-notifications/',
  },
};
